module.exports = __webpack_public_path__ + "img/auto-loan-banking-and-finance.8f5e67f8.png";